module.exports = "/fonts/gothambold1.woff?f6afe209dcde6113f7b99c28f55d1738";